import React from "react";

function IconEdit() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 19">
      <path d="M12.9.7a1 1 0 011.41 0l4.25 4.25a1 1 0 010 1.41l-9.2 9.2a1 1 0 01-1.41 0L3.7 11.3a1 1 0 010-1.41L12.9.7zM1.83 13.12l4.24 4.24-3.65 1.22a1 1 0 01-1.03-.24l-.54-.54a1 1 0 01-.24-1.02l1.22-3.66z" />
    </svg>
  );
}

export default IconEdit;
